import { dataSourceWholeItems } from '@/resources/data-source';
import { WeatherType } from './types';

// 天气标签到 WeatherType 枚举的映射
const labelToWeatherTypeMap: Record<string, WeatherType> = {
  晴: WeatherType.Sunny,
  多云: WeatherType.Cloudy,
  阴: WeatherType.Overcast,
  雷阵雨: WeatherType.Thundershower,
  冰雹: WeatherType.Hail,
  雨夹雪: WeatherType.Sleet,
  小雨: WeatherType.LightRain,
  中雨: WeatherType.ModerateRain,
  大雨: WeatherType.HeavyRain,
  小雪: WeatherType.LightSnow,
  中雪: WeatherType.ModerateSnow,
  大雪: WeatherType.HeavySnow,
  雾: WeatherType.Fog,
  冻雨: WeatherType.FreezingRain,
  沙尘暴: WeatherType.Sandstorm,
  浮尘扬沙: WeatherType.FloatingDust,
  浮尘: WeatherType.FloatingDust,
  霾: WeatherType.Haze,
  未知: WeatherType.Unknown
};

// 缓存天气数值到 WeatherType 的映射关系
let cachedWeatherMap: Record<number, WeatherType> | null = null;

// 从 data-source.ts 动态生成天气数值到 WeatherType 的映射
const buildWeatherMap = (): Record<number, WeatherType> => {
  // 如果已缓存，直接返回
  if (cachedWeatherMap) {
    return cachedWeatherMap;
  }

  const weatherMap: Record<number, WeatherType> = {};

  // 从 data-source.ts 中获取 weatherCurrentWeather 配置
  const weatherSourceItem = dataSourceWholeItems.find(
    (item) => item.key === 'weatherCurrentWeather'
  );

  if (!weatherSourceItem?.weatherValueRange?.whole) {
    console.warn('[mapWeatherValueToType] 未找到 weatherCurrentWeather 配置');
    return weatherMap;
  }

  // 遍历 weatherValueRange.whole 配置，生成映射关系
  weatherSourceItem.weatherValueRange.whole.forEach((item) => {
    const weatherType = labelToWeatherTypeMap[item.label];
    if (!weatherType) {
      console.warn(
        `[mapWeatherValueToType] 未找到天气标签 "${item.label}" 对应的 WeatherType`
      );
      return;
    }

    // 添加主 value
    weatherMap[item.value] = weatherType;

    // 添加 values 数组中的所有值
    if (item.values && Array.isArray(item.values)) {
      item.values.forEach((value) => {
        weatherMap[value] = weatherType;
      });
    }
  });

  // 缓存映射关系
  cachedWeatherMap = weatherMap;
  return weatherMap;
};

/**
 * 天气数值映射到 WeatherType
 * 从 data-source.ts 动态读取配置生成映射关系
 * @param weatherValue 天气数值代码
 * @returns 对应的 WeatherType 枚举值，未找到时返回 WeatherType.Unknown
 */
export const mapWeatherValueToType = (weatherValue: number): WeatherType => {
  // 从 data-source.ts 动态生成映射关系（带缓存）
  const weatherMap = buildWeatherMap();
  return weatherMap[weatherValue] ?? WeatherType.Unknown;
};
